import { useEffect, useState } from "react";
import styled from "styled-components";

export default function MonthYearPicker({
    setMonth,
    setYear
}: {
    setMonth: (month: number) => void;
    setYear: (year: number) => void;
}) {

    const date = new Date();
    const currentYear = date.getFullYear();
    const currentMonth = date.getMonth() + 1; // getMonth is zero-indexed, so add 1
    const formattedMonth = currentMonth < 10 ? `0${currentMonth}` : currentMonth;
    const [selectedMonthYear, setSelectedMonthYear] = useState(`${currentYear}-${formattedMonth}`);

    useEffect(() => {
        const newMonthNumber = parseInt(selectedMonthYear.split('-')[1], 10);
        const newYear = parseInt(selectedMonthYear.split('-')[0], 10);
        setMonth(newMonthNumber);
        setYear(newYear);
    }, [selectedMonthYear]);

    return (
        <FlexContainer>
            <h4 className="mr-3">Pick Month/Year</h4>
            <input
                type="month"
                id="monthPicker"
                value={selectedMonthYear}
                min={`${currentYear - 1}-01`} // January of the previous year
                max={`${currentYear}-${formattedMonth}`} // Current month of the current year
                onChange={(e) => setSelectedMonthYear(e.target.value)}
                style={{
                    width: '150px'
                }}
            />

        </FlexContainer>
    );
}

const FlexContainer = styled.div`
    display: flex;
    align-items: baseline;
`;